import { labelids } from "../../assets/data/TkExplanationProperty";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = ["内容入力", "入力内容確認", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050113_02,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "解除年月日",
    keyword: "cancelDate",
    type: "date",
    maxDate: new Date("2099-12-31T00:00:00.000Z"),
    minDate: new Date("1900-01-01T00:00:00.000Z"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "契約を解除する日を登録してください。\n 直接入力していただくか、「カレンダーボタン」にて日付を選択してください。\n  なお、解除日時点で在籍している被共済職員（解除日に退職する職員も含む。）は退職手当金は支給されませんのでご注意ください。",
  },
  {
    title: "解除日における被共済職員数",
    keyword: "maStaffNum",
    type: "text",
    helpicon: true,
    helpText:
      "解除日時点で在籍している全ての被共済職員数（解除日に退職する職員も含む。）です。",
  },
  {
    title: "解除の理由",
    keyword: "cancelReason",
    type: "textarea",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "解除の理由については具体的にご記入ください。例.他の共済制度に加入するため、掛金の負担が大きいため等。",
    inputProps: { maxLength: 85 },
  },
  {
    keyword: "xxxBtn",
    type: "node",
  },
  {
    keyword: "info",
    type: "lineTitle",
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050113_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "facilityList",
    type: "node",
  },
  {
    explanatoryText: "内容を確認後、「次へ」ボタンを押してください。",
    explanatoryTextRule: "<",
    keyword: "explanatoryText",
    type: "explanatoryText",
  },
];

const headList = [
  {
    headTitle: (
      <>
        施設名称
        <TkHelpIcon helpMessage="登録されている施設の名称です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設種類
        <TkHelpIcon helpMessage="登録されている施設等の施設種類・サービス種類です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        従業状況確認
        <TkHelpIcon helpMessage="現在の職員の従業状況が確認できます。契約解除にあたって、職員の従業状況が最新の状態であるか確認してください。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        直近３ヶ月の退職者の証明書
        <TkHelpIcon helpMessage="解除日から遡って直近３ヶ月以内に退職した職員については、退職の事実が分かる証拠書類が必要となります。" />
      </>
    ),
  },
  {
    headTitle: "解除同意書のダウンロード",
  },
  {
    headTitle: (
      <>
        同意書のアップロード
        <TkHelpIcon helpMessage="解除対象となる被共済職員全員の署名及び押印があることを確認し、解除同意書をアップロードしてください。" />
      </>
    ),
  },
];
const contextText = `【従業状況の登録確認】<
　加入者全員の同意による解除手続きを行うにあたって、事前に従業状況を最新の状況に更新いただく必要があります。<
　従業状況が最新になっていない場合には、最初に従業状況の更新をお願いします。<
　従業状況の更新が完了している場合は「次へ」ボタンをクリックしてください。<
　完了していない場合は「従業状況の更新」ボタンをクリックしてください。<
　なお、当該手続きによる解除は退職手当金が支給されません。`;

const contextText2 = `入力された解除年月日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。
<このまま契約解除の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されます。`;

const schema = {
  cancelDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  cancelReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export {
  stepperData,
  fakeTableList,
  schema,
  headList,
  contextText,
  contextText2,
};
